import React, { useState } from "react";
import { Radio } from "@mui/material";
import styles from "./UsersListRow.module.css";
import { isNonEmptyArray } from "../../../../../common/utils";
import { CustomButton, CustomIconButton, CustomTooltip, icon } from "../../../../../common/components";
import { translate } from "../../../../../common/providers";

const UsersListRow = ({
	COMPANY_ROLES,
	isHeader,
	loggedUser,
	onChangeLock,
	onChangeRole,
	onRegenPassword,
	onSelectRow,
	row,
	selectedUser,
}) => {
	const [localRole, setLocalRole] = useState(row.companyRole);
	const [localLocked, setLocalLocked] = useState(row.locked);
	const handleChangeRole = (role) => {
		onChangeRole({ role, user: row, callBack: () => setLocalRole(role) });
	};
	const handleChangeLock = () => {
		onChangeLock({ user: row, callBack: () => setLocalLocked((prev) => !prev) });
	};
	return (
		<div
			key={row.id}
			className={`${styles.row} ${selectedUser === row && styles["row--selected"]}`}
			data-is-header={isHeader}
		>
			<CustomTooltip showWhenOverflow title={row.displayName || row.email}>
				<div className={`${styles.cell} ${styles["cell--55"]} ${styles.overflow}`}>
					{row.displayName || row.email}
				</div>
			</CustomTooltip>
			{isNonEmptyArray(COMPANY_ROLES) &&
				COMPANY_ROLES.map((role) => (
					<div key={role.name} className={`${styles.cell} ${styles["cell--15"]}`}>
						{isHeader ? (
							row[role.name]
						) : (
							<Radio
								checked={localRole === role.name}
								color="primary"
								disabled={row.id === loggedUser.id}
								onChange={() => handleChangeRole(role.name)}
							/>
						)}
					</div>
				))}
			<div className={`${styles.cell} ${styles["cell--175px"]}`}>
				{isHeader ? (
					row.actions
				) : (
					<>
						<CustomIconButton
							icon={icon.faKey}
							tooltip={translate("dsi.user-list.regenerate-password")}
							variant="contained"
							onClick={() => onRegenPassword({ user: row })}
						/>
						<CustomIconButton
							className={styles.tableRow__lockButton}
							icon={(!!localLocked && icon.faLock) || icon.faLockOpen}
							tooltip={
								(!!localLocked && translate("dsi.user-list.unlock-user-access")) ||
								translate("dsi.user-list.lock-user-access")
							}
							variant="contained"
							onClick={handleChangeLock}
						/>
						<CustomButton variant="contained" onClick={() => onSelectRow({ user: row })}>
							{translate("dsi.user-list.details")}
						</CustomButton>
					</>
				)}
			</div>
		</div>
	);
};

export default UsersListRow;
